import callApi from '../../util/apiCaller';

// Export Constants
export const TOGGLE_ADD_POST = 'TOGGLE_ADD_POST';
export const UPDATE_MY_ORGANIZATION_SYNC_TYPE = 'UPDATE_MY_ORGANIZATION_SYNC_TYPE';

export const WINDOW_DIMENSIONS = 'WINDOW_DIMENSIONS';
export const HEADER_HEIGHT = 'HEADER_HEIGHT';
export const FOOTER_HEIGHT = 'FOOTER_HEIGHT';
export const CONTAINER_WIDTH = 'CONTAINER_WIDTH';
export const LOAD_USER_PREFERENCE = 'LOAD_USER_PREFERENCE';
export const UPDATE_USER_PREFERENCE = 'UPDATE_USER_PREFERENCE';

export const LOAD_TABLE_PREFERENCES = 'LOAD_TABLE_PREFERENCES';
export const LOAD_TABLE_PREFERENCE = 'LOAD_TABLE_PREFERENCE';
export const ADD_TABLE_PREFERENCE_COLUMN = 'ADD_TABLE_PREFERENCE_COLUMN';
export const UPDATE_TABLE_PREFERENCE_COLUMN = 'UPDATE_TABLE_PREFERENCE_COLUMN';
export const DELETE_TABLE_PREFERENCE_COLUMN = 'DELETE_TABLE_PREFERENCE_COLUMN';
export const UPDATE_TABLE_PREFERENCE_COLUMN_POSITIONS = 'UPDATE_TABLE_PREFERENCE_COLUMN_POSITIONS';
export const LOAD_TABLE_PREFERENCE_META_DATA = 'LOAD_TABLE_PREFERENCE_META_DATA';
export const LOAD_USER_SYNC_PERMISSIONS = 'LOAD_USER_SYNC_PERMISSIONS';
export const LOAD_ORGANIZATION_SYNC_PERMISSIONS = 'LOAD_ORGANIZATION_SYNC_PERMISSIONS';

export const APP_HIDE_SYNC_TOAST = 'APP_HIDE_SYNC_TOAST';
export const APP_UNHIDE_SYNC_TOAST = 'APP_UNHIDE_SYNC_TOAST';
export const APP_SHOULD_SHOW_SYNC_TOAST = 'APP_SHOULD_SHOW_SYNC_TOAST';
export const APP_SHOULD_HIDE_SYNC_TOAST = 'APP_SHOULD_HIDE_SYNC_TOAST';

// Export Actions
export function hideSyncToast() {
  return {
    type: APP_HIDE_SYNC_TOAST,
  };
}
export function unhideSyncToast() {
  return {
    type: APP_UNHIDE_SYNC_TOAST,
  };
}

export function shouldShowSyncToast() {
  return {
    type: APP_SHOULD_SHOW_SYNC_TOAST,
  };
}
export function shouldHideSyncToast() {
  return {
    type: APP_SHOULD_HIDE_SYNC_TOAST,
  };
}


export function toggleAddPost() {
  return {
    type: TOGGLE_ADD_POST,
  };
}

export function updateMyOrganization(organization) {
  return {
    type: UPDATE_MY_ORGANIZATION_SYNC_TYPE,
    organization,
  };
}

export function updateMyOrganizationSyncType(syncType) {
  return dispatch => callApi('organizations/my-organization', 'PUT', { sync_type: syncType }).then(res => dispatch(updateMyOrganization(res.organization)));
}


export function changeWindowDimensions(width, height) {
  return {
    type: WINDOW_DIMENSIONS,
    width,
    height,
  };
}
export function changeHeaderHeight(height) {
  return {
    type: HEADER_HEIGHT,
    height,
  };
}
export function changeFooterHeight(height) {
  return {
    type: FOOTER_HEIGHT,
    height,
  };
}
export function changeContainerWidth(width) {
  return {
    type: CONTAINER_WIDTH,
    width,
  };
}

export function fetchUserPreference() {
  return dispatch => callApi('preferences', 'GET').then(preferences => dispatch({
    type: LOAD_USER_PREFERENCE,
    preferences,
  }));
}
export function updatePreference(name, value) {
  return (dispatch) => {
    const p = callApi(`preferences/${name}`, 'POST', { value });
    p.then(preference => dispatch({
      type: UPDATE_USER_PREFERENCE,
      preference,
    }));
    return p;
  };
}


export function fetchTablePreferences() {
  return dispatch => callApi('table-preferences', 'GET').then(preferences => dispatch({
    type: LOAD_TABLE_PREFERENCES,
    preferences,
  }));
}
export function fetchTablePreference(tableName) {
  return dispatch => callApi(`table-preferences/${tableName}`, 'GET').then(({ columns }) => dispatch({
    type: LOAD_TABLE_PREFERENCE,
    tableName,
    columns,
  }));
}
export function resetTablePreference(tableName) {
  return (dispatch) => {
    const p = callApi(`table-preferences/${tableName}`, 'DELETE');
    p.then(({ columns }) => dispatch({
      type: LOAD_TABLE_PREFERENCE,
      tableName,
      columns,
    }));
    return p;
  };

}

export function addTablePreferenceColumn(tableName, params) {
  return (dispatch) => {
    const p = callApi(`table-preferences/${tableName}/columns`, 'POST', params);
    p.then(column => dispatch({
      type: ADD_TABLE_PREFERENCE_COLUMN,
      tableName,
      column,
    }));
    return p;
  };
}

export function updateTablePreferenceColumn(tableName, id, params) {
  return (dispatch) => {
    const p = callApi(`table-preferences/${tableName}/columns/${id}`, 'PUT', params);
    p.then(column => dispatch({
      type: UPDATE_TABLE_PREFERENCE_COLUMN,
      tableName,
      id,
      column,
    }));
    return p;
  };
}

export function deleteTablePreferenceColumn(tableName, id) {
  return (dispatch) => {
    const p = callApi(`table-preferences/${tableName}/columns/${id}`, 'DELETE');
    p.then(() => dispatch({
      type: DELETE_TABLE_PREFERENCE_COLUMN,
      tableName,
      id,
    }));
    return p;
  };
}

export function updateTablePreferenceColumnPositions(tableName, positions = []) {
  return (dispatch) => {
    const p = callApi(`table-preferences/${tableName}/columns`, 'PUT', { positions });
    p.then(columns => dispatch({
      type: UPDATE_TABLE_PREFERENCE_COLUMN_POSITIONS,
      tableName,
      columns,
    }));
    return p;
  };
}

export function loadTablePreferenceMetaData() {
  return (dispatch) => {
    const p = callApi('table-preferences/meta-data', 'GET');
    p.then(({ meta }) => dispatch({
      type: LOAD_TABLE_PREFERENCE_META_DATA,
      meta,
    }));
    return p;
  };
}

export function loadUserSyncPermissions(orgId, userId) {
  return (dispatch) => {
    const p = callApi(`organizations/${orgId}/users/${userId}/sync-permissions`, 'GET');
    p.then(
      (results) => dispatch({
        type: LOAD_USER_SYNC_PERMISSIONS,
        results,
        userId,
      })
    );
    return p;
  };
}



export function loadOrganizationSyncPermissions(organizationId) {
  return (dispatch) => {
    const p = callApi(`organizations/${organizationId}/sync-permissions`, 'GET');
    p.then(
      (results) => dispatch({
        type: LOAD_ORGANIZATION_SYNC_PERMISSIONS,
        results,
        organizationId,
      })
    );
    return p;
  };
}

export function fetchOrganizationSAMLUrl(organizationId) {
  return () => {
    const p = callApi(`organizations/${organizationId}/saml-login-url`, 'GET');
    return p;
  };
}

